type observeWindowSizeHandler = (dimensions: { height: number, width: number }) => void
export function observeWindowSize (handler: observeWindowSizeHandler): (() => void) | null {
  if (!handler) return null

  function listener (ev: Event): void {
    if (ev.target !== window) return
    const dimensions = {
      height: window.innerHeight,
      width: window.innerWidth,
    }
    handler(dimensions)
  }

  window.addEventListener('resize', listener)
  const unobserveWindowSize = (): void => window.removeEventListener('resize', listener)
  return unobserveWindowSize
}
